export const systemStack = `Inter, system-ui, sans-serif`;

export * from "./Inter";

export * from "./Poppins";
